import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LexiTipsLogo from "@/assets/lexi-tips-logo.svg";
import { Button } from "@/components/ui/button";

const GDRIVE_LINK = import.meta.env.VITE_MEDIA_GDRIVE_LINK;
const COUNTDOWN_SECONDS = 5;

function MediaKit() {
  const [countdown, setCountdown] = useState(COUNTDOWN_SECONDS);
  const navigate = useNavigate();

  useEffect(() => {
    // Countdown timer
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown(countdown - 1);
      }, 1000);
      return () => clearTimeout(timer);
    } else {
      // Redirect when countdown reaches 0
      window.location.href = GDRIVE_LINK;
    }
  }, [countdown]);

  const handleRedirect = () => {
    window.location.href = GDRIVE_LINK;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-pink-50 via-white to-purple-50 flex items-center justify-center px-4 py-12">
      <div className="max-w-2xl w-full">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <img
            src={LexiTipsLogo}
            alt="Lexi.tips Logo"
            className="h-20 w-auto"
          />
        </div>

        {/* Main Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12 text-center border border-gray-100">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Media Kit
          </h1>
          
          <p className="text-gray-600 text-lg mb-8">
            Access our brand assets, logos, and media resources
          </p>

          {/* Countdown Display */}
          <div className="mb-8">
            <p className="text-gray-500 text-sm">
              Redirecting automatically in {countdown} second{countdown !== 1 ? 's' : ''}...
            </p>
          </div>

          {/* Manual Redirect Button */}
          <Button
            onClick={handleRedirect}
            className="inline-block px-8 py-4 bg-brand-pink text-white rounded-lg font-semibold hover:bg-[#e391c4] transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105 text-lg"
            data-gtm-element-id="mediakit_redirect_button"
          >
            Get Media Kit Now
          </Button>

          {/* Info Text */}
          <p className="text-gray-400 text-xs mt-8">
            You'll be redirected to our Google Drive folder with all brand assets
          </p>
        </div>
      </div>
    </div>
  );
}

export default MediaKit;

